import styles from './Card.module.css';

// Generic surface. Pass `as` to render a different element (e.g. button, a).
// `label` adds a bracket tag in the top-left corner (e.g. "[ WORKSPACE ]").
// `accent` swaps the white hard-shadow for the neon accent color.
export default function Card({
  as: Tag = 'div',
  interactive = false,
  accent = false,
  label,
  className = '',
  children,
  ...rest
}) {
  const classes = [
    styles.card,
    interactive ? styles.interactive : '',
    accent ? styles.accent : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  const dataAttrs = label ? { 'data-label': label } : {};

  return (
    <Tag className={classes} {...dataAttrs} {...rest}>
      {children}
    </Tag>
  );
}
